import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { CaseConverter } from "../components/CaseConverter";
import { CcBreadcrumb } from "../components/CcBreadcrumb";
import { CcExplainer } from "../components/CcExplainer";

export function CaseConverterPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <CcBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.cc_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.cc_intro()}
          </p>
        </header>

        <CaseConverter />

        <CcExplainer
          howTo={m.cc_howto()}
          faqs={[
            { q: m.cc_faq1_q(), a: m.cc_faq1_a() },
            { q: m.cc_faq2_q(), a: m.cc_faq2_a() },
            { q: m.cc_faq3_q(), a: m.cc_faq3_a() },
            { q: m.cc_faq4_q(), a: m.cc_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
